module.exports = __webpack_public_path__ + "img/LOGO.638df0b3.png";